import React from "react"
import TargetPreciselyImage from "../../../../../components/staticQuery/platform/automation/TargetPreciselyImage"
import FlexibleDatesImage from "../../../../../components/staticQuery/platform/offers/FlexibleDatesImage"
import OfferPowerfulActionsImage from "../../../../../components/staticQuery/platform/offers/OfferPowerfulActions"
import P from "../../../../../components/typography/P"
import GearGraphic from "../../../../../images/platform/automation/gear.svg"

const DescriptionText = () => (
  <>
    <P>
      In addition to sending Offers, you can add Actions that trigger based on
      when an Offer is awarded, redeemed or expires.
    </P>
    <P>
      Actions can update a Contact, deliver an SMS or Email Notification to your
      staff, transfer a Contact to an Automation Sequence and more.
    </P>
  </>
)

const offerPowerfulActionsData = {
  titleIcon: GearGraphic,
  title: "Powerful Actions",
  description: <DescriptionText />,
  graphic: <OfferPowerfulActionsImage />,
  imageLeft: true,
  textLong: false,
  tint: "#F2F8F3",
  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 6vw))",
  benefits: [
    {
      benefitName: "Trigger on Offer Award, Redemption or Expiration",
    },
    {
      benefitName: "Update Contacts with Lists, Interests, Tags and more",
    },
    { benefitName: "Send to an Automation Sequence" },
    { benefitName: "Deliver Notifications by SMS or Email" },
  ],
}

export default offerPowerfulActionsData
